<template>
  <div class="loginElement">
   
    <template >
      <el-form :model="ruleForm" :rules="rules" label-position="left" ref="ruleForm" label-width="100px">
        <el-form-item label="帐号：" prop="username">
          <el-input  placeholder="请输入帐号"
              onkeydown="if(event.keyCode==13) {document.getElementById('btn').click();return false;}"
              v-model="ruleForm.username"></el-input>
        </el-form-item>
        <el-form-item  label="密码：" prop="password">
          <el-input type="password" show-password placeholder="请输入密码"
                    onkeydown="if(event.keyCode==13) {document.getElementById('btn').click();return false;}"
                    v-model="ruleForm.password"/>
        </el-form-item>
        <el-form-item label="验证码：" prop="code">
          <div style="display: flex; align-items: center;">
            <el-input type="text"  placeholder="请输入验证码"
                      onkeydown="if(event.keyCode==13) {document.getElementById('btn').click();return false;}"
                      v-model="ruleForm.code"></el-input>
            <div class="login-code">
              <img :src="codeUrl"
                   @click="getCode"
                   alt="验证码">
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div style="width: 100%;text-align: center">
        <el-button style="width: 100%;" type="primary" id="btn" @click="login()">登录</el-button>
      </div>
    </template>
  </div>
</template>

<script>
import * as u from "@/utils/util";
import { Decrypt } from "@/utils/util";

// 自动登录信息存储键（使用 sessionStorage，不受 localStorage.clear() 影响）

export default {
  name: "loginElement",
  data(){
    return{
      // 自动登录时显示 loading
      autoLogging: false,
      //登录表单
      ruleForm: { 
        code: '',
        randomStr: u.uuid(),
      },
      //登录校验
      rules: {
        username: [
          {required: true, message: '请输入帐号', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
        ],
      },
      //验证码图片url
      codeUrl: "",
    }
  },
  created(){
    // 检测 URL 中是否含有 username 参数（自动登录流程）
    // if (window.location.href.indexOf("username") !== -1) {
    //   this.autoLogging = true;
    //   try {
    //     const rawUser = this.getUrlCode("username");
    //     const rawPass = this.getUrlCode("password");
    //     const username = Decrypt(decodeURIComponent(rawUser));
    //     const password = Decrypt(decodeURIComponent(rawPass));
    //     // 填入表单
    //     this.ruleForm.username = username;
    //     this.ruleForm.password = password;
    //     this.ruleForm.code = '6363';
    //     this.ruleForm.checkKey = new Date().getTime();
    //     // 用 history.replaceState 清理 URL 参数，不触发页面刷新也不触发路由变化
    //     const cleanUrl = window.location.href.split('?')[0];
    //     window.history.replaceState(null, '', cleanUrl);
    //     // 先获取验证码（需要 randomStr），完成后直接登录
    //     this.$nextTick(() => {
    //       this.getCode().then(() => {
    //         this.confirmLogin(true);
    //       });
    //     });
    //   } catch(e) {
    //     console.error('[AutoLogin] 解密失败', e);
    //     this.getCode();
    //   }
    // } else {
      // 正常访问登录页
    // }
  },
  mounted(){},
  methods: {
    
  }
}
</script>


<style scoped lang="scss">

</style>
